import { useState } from "react"
import { Button, Col, Container, Row, Stack } from "react-bootstrap"
import { useParams } from "react-router"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"
import { useDeleteBuildingAmenityMutation, useGetBuildingAmenityByIdQuery } from "../../../services/bClientApi"
import BuildingAmenityEntry from "../../../Components/BuildingAmenity/BuildingAmenityEntry/BuildingAmenityEntry"

export default function DeleteBuildingAmenityPage() {

    const [
        deleteBuildingAmenity,
        {
            isLoading: deleteLoading,
            error: deleteError
        }
    ] = useDeleteBuildingAmenityMutation()

    const { buildingAmenityId = '' } = useParams()
    const dispatch = useAppDispatch()

    const [deleteClicked, setDeleteClicked] = useState(false)

    const {
        data,
        error,
        isLoading
    } = useGetBuildingAmenityByIdQuery(buildingAmenityId, { skip: !buildingAmenityId || deleteClicked })
    const buildingAmenityData = data || {}

    const buildingAmenityDeleteFn = async () => {
        if (buildingAmenityId) {
            const deleteValue = await deleteBuildingAmenity(buildingAmenityId).unwrap()
            if (deleteValue) {
                dispatch(navigateTo('/building-amenities/'))
            }
        }
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Delete Building Amenity</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {deleteError && (<>{JSON.stringify(deleteError)}<br /></>)}

                    {buildingAmenityId && buildingAmenityData && !isLoading && (
                        <div className="building-amenity-info">
                            <div className="mb-4">
                                <h4>Building Amenity to Delete</h4>
                                <BuildingAmenityEntry
                                    buildingAmenityData={buildingAmenityData}
                                    fullView={true}
                                    showActions={false}
                                />
                            </div>

                            <Stack gap={3}>
                                <div className="alert alert-warning">
                                    <strong>Warning!</strong> Are you sure you want to delete this building amenity? This action cannot be undone.
                                </div>
                                <div>
                                    <Button
                                        variant="secondary"
                                        className="me-2"
                                        onClick={() => dispatch(navigateTo(`/building-amenity/${buildingAmenityId}`))}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="warning"
                                        onClick={() => setDeleteClicked(true)}
                                        disabled={deleteClicked}
                                    >
                                        Delete Building Amenity
                                    </Button>
                                </div>
                                {deleteClicked && (
                                    <div className="alert alert-danger">
                                        <strong>Final Confirmation:</strong> This building amenity will be permanently deleted. This action cannot be undone.
                                        <br /><br />
                                        <Button
                                            variant="danger"
                                            disabled={deleteLoading}
                                            onClick={() => {
                                                buildingAmenityDeleteFn()
                                            }}
                                        >
                                            {deleteLoading ? 'Deleting...' : 'Confirm Delete Building Amenity'}
                                        </Button>
                                    </div>
                                )}
                            </Stack>

                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}
